import { triplaServer } from 'src/apis/server'
import { serialize } from 'object-to-formdata'

export function startRestaurantReservation(restaurantId, restaurantCode = null, chatId = null) {
  return triplaServer.post(
    `app/reservations/start`,
    serialize(
      {
        restaurant_id: restaurantId,
        restaurant_code: restaurantCode,
        chat_id: chatId
      },
      { nullsAsUndefineds: true }
    )
  )
}

export default {
  startRestaurantReservation
}
